import API from './api';

export default class User extends API {
  constructor(config = {}) {
    config.path = 'v1/users';

    super(config);
  }

  identifier(resource = '', params = {}) {
    return this.get('identifier', params);
  }
}



// WEBPACK FOOTER //
// ./src/services/request/user.js